const tabNavs = [
  {
    name: '首页',
    link: '/'
  },
  {
    name: '招聘岗位',
    link: '/jobs'
  },
  {
    name: '集团简介',
    link: '/about'
  },
  {
    name: '招聘公告',
    link: '/announcement'
  },
  {
    name: '招聘帮助',
    link: '/help'
  },
  {
    name: '个人中心',
    link: '/user'
  },
]

export default tabNavs
